import { QueryFn } from '@percent/workplace-giving/common/hooks/useQuery/useQuery.types'
import { config } from '@percent/workplace-giving/config/config'
import { GetRegistriesListResponse, GetRegistriesQuery } from './registries.types'

export const getRegistries: QueryFn<['getRegistries', GetRegistriesQuery], GetRegistriesListResponse> = async (
  client,
  queryKey
) => {
  const [, query] = queryKey

  const res = await client.get<GetRegistriesListResponse>(`v1/registries`, {
    params: {
      countryCode: query.countryCode,
      supportedTypes: query.supportedTypes
    },
    headers: {
      Authorization: config.keys.publicKey
    },
    withCredentials: true
  })

  return res.data
}
